import { SiteMetrics } from "@/components/site-metrics";
import { Nav, Footer } from "@/components/sections";
import { ShowcaseTwoHero, ShowcaseTwoStats, ShowcaseTwoOffers, ShowcaseTwoReport } from "@/components/showcase/showcase-two-opening";
import { ShowcaseTwoProblem, ShowcaseTwoResults, ShowcaseTwoAuthorFaq, ShowcaseTwoContact } from "@/components/showcase/showcase-two-details";

export function HomePage() {
  return <div className="min-h-screen bg-background text-foreground">
    <Nav />
    <main id="main-content">
      <ShowcaseTwoHero /><ShowcaseTwoStats /><SiteMetrics /><ShowcaseTwoOffers /><ShowcaseTwoReport />
      <ShowcaseTwoProblem /><ShowcaseTwoResults /><ShowcaseTwoAuthorFaq /><ShowcaseTwoContact />
    </main>
    <Footer />
  </div>;
}
